import { Box, CardMedia, Typography } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';

const EcosystemDetails = () => {
    const { id } = useParams()
    const [ecosystems, setEcosystems] = React.useState([]);

    React.useEffect(() => {
        fetch(`../ecosystem.json`)
            .then(res => res.json())
            .then(data => setEcosystems(data));
    }, [])
    const fondEcosystem = ecosystems.filter(Case => (Case.id == id))

    const handelBack = e => {
        e.preventDefault()
        window.history.back()
    }

    return (
        <div>
            {fondEcosystem.map(ecosystem =>
                <Box key={ecosystem.id} sx={{ mx: { xs: 1.2, sm: 3.5, md: 6, lg: 9, xl: 28 }, mb: { xs: '60px', md: '90px' } }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', py: '20px' }}>
                        <Box className="first-box" sx={{ height: { xs: '30px', sm: '40px', md: '50px', lg: '61px' }, width: { xs: '9px', sm: '12px', md: '15px', lg: '21px' }, background: '#4741E4' }}></Box>
                        <Box className="second-box" sx={{ height: { xs: '30px', sm: '40px', md: '50px', lg: '61px' }, width: { xs: '9px', sm: '12px', md: '15px', lg: '21px' }, background: '#7E89FF' }}></Box>
                        <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: { xs: '20px', sm: '22px', md: '25px', lg: '30px' }, lineHeight: { xs: '30px', lg: '45px' }, color: '#383838', textAlign: 'left', pl: { xs: '18px', sm: '22px', md: '28px', lg: '36px' } }}>
                            The <span style={{ fontWeight: 700, color: '#433ED1' }}>ecosystem</span>
                        </Typography>
                    </Box>

                    <Typography sx={{ fontFamily: 'poppins', fontWeight: 600, fontSize: { xs: '20px', sm: '22px', md: '25px', lg: '30px' }, lineHeight: { xs: '30px', sm: '35px', md: '40px', lg: '45px' }, color: '#433ED1', textAlign: 'left', alignItems: 'center', my: { sm: '9px', md: '15px' } }}><i onClick={handelBack} style={{ marginRight: '18px' }} className="fas fa-solid fa-arrow-left"></i> {ecosystem.name}</Typography>

                    <Box sx={{ height: { xs: '300px', sm: '320px', md: '400px', lg: '490px' }, display: 'flex', alignItems: 'center' }}>
                        <CardMedia
                            component="img"
                            sx={{ width: { xs: '80%', sm: '350px', md: '420px', lg: '500px' }, mx: 'auto' }}
                            image={ecosystem.img}
                            alt="logo"
                        />
                    </Box>

                    <Box sx={{ pl: { sm: '17px', md: '27px', lg: '50px', xl: '70px' }, pr: { xl: '70px' } }}>
                        <Typography sx={{ fontFamily: 'poppins', fontWeight: 600, fontSize: { xs: '16px', md: '18px' }, lineHeight: { xs: '30px', sm: '35px', md: '40px', lg: '50px' }, color: '#383838', textAlign: 'left', pb: '10px' }}>{ecosystem.description}</Typography>
                        <Typography sx={{ fontFamily: 'poppins', fontWeight: 400, fontSize: { xs: '16px', md: '18px' }, lineHeight: { xs: '30px', sm: '35px', md: '40px', lg: '50px' }, color: '#383838', textAlign: 'left', pt: '10px' }}>{ecosystem.bottom_details}</Typography>
                    </Box>
                </Box>
            )}
        </div>
    );
};

export default EcosystemDetails;